module.exports = __webpack_public_path__ + "img/facettedconnections@2x.283f316.webp";